import React from "react"
import CssBaseline from "@mui/material/CssBaseline";
import ApplicationBar from "@/components/molecules/ApplicationBar";

export interface HeaderProps {
    open: boolean,
    toggleDrawer: () => void
}

export const Header = (props: HeaderProps) => {
    const { open, toggleDrawer } = props;
    return <React.Fragment>
        <CssBaseline />

        {/* 一番上のバー*/}
        <ApplicationBar open={open} toggleDrawer={toggleDrawer} />
    </React.Fragment>
}